import { Link, useNavigate } from 'react-router-dom';
import Title from './Title';
import './wishlist.css';
import { useEffect, useState, useTransition } from 'react';
import * as Wish from "../../network/api/wish";
import { getProductsOfCart } from '../../network/api/product';
import ProductInCart from '../cart/ProductInCart';
import ProductInCartForWishList from '../cart/ProductInCartForWishList.jsx';

const Wishlist = (props) => {
  const [wishItems, setWishItems] = useState([]);
  const [ProductItems, setProductItems] = useState([]);
  const [isEmpty, setIsEmpty] = useState(true);

  const load = async () => {
    const productArr = []
    const wishArr = await Wish.get_wish()
    if (wishArr?.length === 0) {
      setIsEmpty(true)
    } else {
      wishArr?.forEach(element => {
        productArr.push(element.product_id)
      });
      const products = await getProductsOfCart(productArr)
      setWishItems(wishArr)
      setProductItems(products)
      setIsEmpty(false)
      props.update_p()
    }
  }

  useEffect(() => {
    load()
  }, [isEmpty]);


  return (
    <div className="d-flex flex-column w-100 ">
      <Title title={props.getUserName} text="أهلا بك فى حسابك" />
      <div className="wishlist flex-grow-1 w-100 p-3">
        <div className="title-and-icon">
          {HeartBlackIcon} <span>المفضلة</span>
        </div>
        {isEmpty ?
          <div className="free-page w-100 py-5 ">
            <div className='content d-flex flex-column align-items-center'>
              <div className='img'>
                {HeartWhiteIcon}
              </div>
              <p>ما في منتجات مفضلة سابقة </p>
              <span>اشتري الحين!</span>
            </div>
            <div className='d-flex justify-content-center' style={{ marginTop: '0px', marginBottom: '18px ' }}>
              <Link to={'/'} className='btn'>ابدأ بالتسوق</Link>
            </ div>
          </div>
          :
          <>
            {ProductItems?.map((product, index) => {
              return <>
                <ProductInCartForWishList
                  key={product._id}
                  product={product}
                  personal={props.personal}
                  wish={wishItems[index]}
                  load={load}
                  update_p={props.update_p}
                />
               
              </>
            })}
          </>
        }
      </div>
    </div>
  )
}

export default Wishlist


const HeartWhiteIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1606_10025" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
      <path d="M0 0H16V16H0V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_1606_10025)">
      <mask id="mask1_1606_10025" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <path d="M1.51756 3.02385L1.51745 3.02406C0.469782 4.99652 1.19291 6.9237 2.13871 7.96339C2.13883 7.96353 2.13896 7.96367 2.13909 7.96381L8.10866 14.5089L13.9223 8.02024C14.8198 6.86911 15.1342 5.70702 14.9492 4.40283L14.9492 4.40274C14.6874 2.55519 13.3818 1.2519 11.9275 1.07086C11.0216 0.959358 10.1468 1.24602 9.44364 1.91351C9.25182 2.09572 9.07879 2.3008 8.92651 2.5263L8.11431 3.729L7.27969 2.54175C7.0996 2.28557 6.88778 2.05068 6.64705 1.84138L1.51756 3.02385ZM1.51756 3.02385C2.09494 1.9362 2.96718 1.26439 3.84567 1.07003M1.51756 3.02385L3.84567 1.07003M3.84567 1.07003C4.80006 0.860983 5.81851 1.12197 6.64672 1.84109L3.84567 1.07003Z" stroke="white" stroke-width="2" />
      </mask>
      <g mask="url(#mask1_1606_10025)">
        <path d="M0.634299 2.55497C-0.663027 4.99746 0.251068 7.37481 1.39947 8.63684L8.11527 16.0001L14.6891 8.66295C15.7572 7.30556 16.1667 5.86571 15.9393 4.26242C15.625 2.0447 14.026 0.324043 12.0505 0.0784441C10.8388 -0.0709103 9.66851 0.321109 8.75493 1.18848C8.50904 1.42205 8.28939 1.6829 8.09778 1.96665C7.87067 1.64359 7.60421 1.3484 7.30277 1.08637C6.25236 0.174101 4.91516 -0.188281 3.6307 0.0934089C2.41413 0.362188 1.32231 1.2589 0.634299 2.55497Z" stroke="white" stroke-width="2" />
      </g>
    </g>
  </svg>
)

const HeartBlackIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1606_10120" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
      <path d="M0 0H16V16H0V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_1606_10120)">
      <mask id="mask1_1606_10120" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <path d="M1.51756 3.02385L1.51745 3.02406C0.469782 4.99652 1.19291 6.9237 2.13871 7.96339C2.13883 7.96353 2.13896 7.96367 2.13909 7.96381L8.10866 14.5089L13.9223 8.02024C14.8198 6.86911 15.1342 5.70702 14.9492 4.40283L14.9492 4.40274C14.6874 2.55519 13.3818 1.2519 11.9275 1.07086C11.0216 0.959358 10.1468 1.24602 9.44364 1.91351C9.25182 2.09572 9.07879 2.3008 8.92651 2.5263L8.11431 3.729L7.27969 2.54175C7.0996 2.28557 6.88778 2.05068 6.64705 1.84138L1.51756 3.02385ZM1.51756 3.02385C2.09494 1.9362 2.96718 1.26439 3.84567 1.07003M1.51756 3.02385L3.84567 1.07003M3.84567 1.07003C4.80006 0.860983 5.81851 1.12197 6.64672 1.84109L3.84567 1.07003Z" stroke="white" stroke-width="2" />
      </mask>
      <g mask="url(#mask1_1606_10120)">
        <path d="M0.634299 2.55497C-0.663027 4.99746 0.251068 7.37481 1.39947 8.63684L8.11527 16.0001L14.6891 8.66295C15.7572 7.30556 16.1667 5.86571 15.9393 4.26242C15.625 2.0447 14.026 0.324043 12.0505 0.0784441C10.8388 -0.0709103 9.66851 0.321109 8.75493 1.18848C8.50904 1.42205 8.28939 1.6829 8.09778 1.96665C7.87067 1.64359 7.60421 1.3484 7.30277 1.08637C6.25236 0.174101 4.91516 -0.188281 3.6307 0.0934089C2.41413 0.362188 1.32231 1.2589 0.634299 2.55497Z" stroke="black" stroke-width="2" />
      </g>
    </g>
  </svg>
)